var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetaMaskToken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5738 1.22052L22.0457 12.8193L24.7438 5.97629L36.5738 1.22052Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3291 1.22052L17.3761 12.8193L14.694 5.9317L2.3291 1.22052Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1945 28.2842L27.2341 34.6693L35.7084 37.1214L38.1302 28.4252L31.1945 28.2842Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.772461 28.4252L3.18284 37.1214L11.6685 34.6693L7.71759 28.2842L0.772461 28.4252Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4079 17.5586L9.07422 21.2682L17.376 21.6564L17.0952 12.267L11.4079 17.5586Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0137 17.6054L22.2377 12.267L22.0457 21.6564L30.3474 21.2726L28.0137 17.6054Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6685 34.9121L16.8571 32.3601L12.3875 28.8366L11.6685 34.9121Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5647 32.3601L27.2344 34.9121L26.5873 28.8366L22.5647 32.3601Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2344 34.7639L22.5647 32.1506L22.9364 35.6496L22.8957 37.1215L27.2344 34.7639Z",
    fill: "#FEF9F9",
    stroke: "#FEF9F9",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6685 34.7639L16.4892 37.1215L16.4591 35.6496L16.8571 32.1506L11.6685 34.7639Z",
    fill: "#FEF9F9",
    stroke: "#FEF9F9",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3384 26.075L12.1875 24.7583L15.1162 23.3134L16.3384 26.075Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5647 26.075L23.7827 23.3134L26.7156 24.7583L22.5647 26.075Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9758 34.9121L12.7064 28.2842L8.03662 28.4306L11.9758 34.9121Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7158 28.2842L27.444 34.9121L31.3856 28.4306L26.7158 28.2842Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3474 21.1042L22.0457 21.5004L22.8139 26.0751L24.0403 23.3206L26.9938 24.7618L30.3474 21.1042Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4424 24.7618L15.3813 23.3206L16.6078 26.0751L17.376 21.5004L9.07422 21.1042L12.4424 24.7618Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07422 21.1042L12.7062 28.8367L12.5835 24.987L9.07422 21.1042Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8538 24.987L26.7158 28.8367L30.3478 21.1042L26.8538 24.987Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3505 21.6566L16.3384 26.2163L17.6227 31.5984L17.895 24.5124L17.3505 21.6566Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8811 21.6566L21.5266 24.4969L21.6974 31.5984L22.5643 26.2163L21.8811 21.6566Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5078 26.2735L21.5266 31.6319L22.2398 32.1504L26.582 28.5688L26.7152 24.9702L22.5078 26.2735Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 24.9702L12.3065 28.5688L16.6609 32.1504L17.3761 31.6319L16.3921 26.2735L12.1875 24.9702Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5689 37.2628L22.6127 35.7952L22.2436 35.4486H16.6592L16.3047 35.7952L16.3338 37.2628L11.6685 34.9122L13.298 36.3316L16.6154 38.7785H22.2874L25.6048 36.3316L27.2343 34.9122L22.5689 37.2628Z",
    fill: "#FEF9F9",
    stroke: "#FEF9F9",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1702 32.1722L21.4689 31.5983H17.4198L16.7185 32.1722L16.3384 36.0168L16.6883 35.6348H22.2004L22.5647 36.0168L22.1702 32.1722Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4073 13.745L38.6494 7.25235L36.787 1.22052L22.5647 12.5835L28.0355 17.5635L35.7662 19.9995L37.467 17.8504L36.7273 17.2782L37.9097 16.1151L37.0083 15.3517L38.1907 14.3814L37.4073 13.745Z",
    fill: "#434343",
    stroke: "#434343",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.772461 7.25235L2.02912 13.745L1.23115 14.3814L2.41355 15.3517L1.51219 16.1151L2.69459 17.2782L1.95486 17.8504L3.65565 19.9995L11.3864 17.5635L16.8571 12.5835L2.63488 1.22052L0.772461 7.25235Z",
    fill: "#434343",
    stroke: "#434343",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5559 20.209L27.8634 17.7902L30.1875 21.5678L26.7158 28.8366L31.3047 28.7728H38.1308L35.5559 20.209Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.505 17.7902L3.45256 20.209L0.772461 28.7728H7.91788L12.7063 28.8366L9.07212 21.5678L11.505 17.7902Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9379 21.7067L22.4342 12.6459L24.6398 6.19135H14.7815L16.9871 12.6459L17.4835 21.7067L17.6734 24.5636L17.6878 31.5981H21.7336L21.7479 24.5636L21.9379 21.7067Z",
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaMaskToken);
export default __webpack_public_path__ + "static/media/meta_mask_token.e1eba8da1b60571843a733d647a5fb08.svg";
export { ForwardRef as ReactComponent };